import { Injectable } from '@angular/core';
import { BackgroundFetchStrategy } from './background-fetch.strategy';
import { IFetchStrategy } from './i-fetch.strategy';
import { AutoFetchStrategy } from './auto-fetch.strategy';
import { FetchStrategy } from './fetch-strategy.enum';

@Injectable({ providedIn: 'root' })
export class FetchStrategyResolver {
  private strategies: { [str in keyof typeof FetchStrategy]: IFetchStrategy };

  public constructor(
    private readonly backgroundTaskStrategy: BackgroundFetchStrategy,
    private readonly autoFetchStrategy: AutoFetchStrategy,
  ) {}

  public getStrategy(strategy: FetchStrategy): IFetchStrategy {
    const strategies =
      this.strategies ||
      (this.strategies = {
        Autofetch: this.autoFetchStrategy,
        BackgroundFetch: this.backgroundTaskStrategy,
      });

    const result = strategies[FetchStrategy[strategy]];
    if (!result) {
      throw new Error(`Strategy ${strategy} not found`);
    }

    return result;
  }
}
